(function(angular) { 
    'use strict';
    
    angular
    .module('webcomm')
    .directive('channelActivity', ['$interval', function ($interval) {

        function link(scope, element, attrs ) {
            var second = 0;
            var timeoutId;

            scope.resetTimer = function() {
                second = 0;
            };

            scope.$on('$destroy', function(){
                $interval.cancel(timeoutId);
            });

            timeoutId = $interval(function() {
                second++;
            }, 1000);
        }

        return {
            link: link,
            restrict: 'E',
            scope: {},
            bindToController: {
                channel: '=',
                selectedChannelId: '=',
                showTimer: '=',
                channelSpeaking: '&onChannelSpeaking'
            },
            templateUrl: 'app/main/channel/channelActivity.html',
            controller: 'ChannelActivityController',
            controllerAs: 'cac'
        };
    }])
    .controller(
        'ChannelActivityController', [
            '$scope',
            '$log',
            '$timeout',
            '$filter',
            'pttService',
            'muteService',
            'channelModel',
            'endpointStatusService',
            function($scope, $log, $timeout, $filter, pttService, muteService, channelModel, endpointStatusService) {
                
                var cac = this;
                
                cac.activity = {
                    message: '',
                    isVisible: false
                };

                var latestSpeakingMessage = "";
                
                var activityMessageTimer = 0;

                function mapVariableName(isNotSelected) {
                    return {isNotSelected};
                }

                var unbindChannelSelected = $scope.$on('channelModel.channelSelected', function(event, channel) {
                    // only change the highlight if on an unselected channel
                    cac.channelSpeaking(mapVariableName(cac.channel.id !== channel.id && endpointStatusService.isAnyoneSpeakingOnChannel(cac.channel.id)));
                });

                var unbindFeedEventReceived = $scope.$on('feedModel.feedEventReceived', function(event, data) {
                    if (data.channelId === cac.channel.id) {
                        cac.activity.isVisible = true;

                        if (data.type === "text-message") {

                            cac.activity.message = $filter('truncate')(data.name) + " sent text.";

                            if (activityMessageTimer) {
                                $timeout.cancel(activityMessageTimer);
                            }

                            // hide notification after 3 seconds
                            activityMessageTimer = $timeout(
                                function() {
                                    cac.activity.message = latestSpeakingMessage;
                                    cac.activity.isVisible = !!latestSpeakingMessage ? true : false;
                                },
                                3000
                            );
                        }
                    }
                });

                var unbindSpeakersChangedEvent = $scope.$on('endpointStatusService.speakersChanged', function (event, data) {
                    if (data.channelId === cac.channel.id) {

                        if (data.speakerCount) {
                            cac.activity.isVisible = true;
                            latestSpeakingMessage = cac.activity.message = data.message;

                            // only change the highlight if on an unselected channel
                            if (cac.selectedChannelId && data.channelId !== cac.selectedChannelId) {
                                //$log.debug("highlighting by speakersChanged: ", data.channelId);
                                cac.channelSpeaking(mapVariableName(true));
                            }
                        }
                        else {
                            latestSpeakingMessage = cac.activity.message = "";
                            cac.activity.isVisible = false;
                            cac.channelSpeaking(mapVariableName(false));
                        }
                    }
                });

                $scope.$on(
                    "$destroy",
                    function(event) {
                        unbindChannelSelected();
                        unbindFeedEventReceived();
                        unbindSpeakersChangedEvent();
                        $timeout.cancel(activityMessageTimer);
                    }
                );
            }]);
})(angular);